import axios from 'axios';

const KEY = 'OshE8MJc67n55swlUL62XGqaeZbfyWAe';

export default axios.create({
  baseURL: 'https://api.nytimes.com/svc',
  params: {
    'api-key': KEY,
  },
});
